(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.SGFHPlanning15 = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const SQFT_TO_M2 = 0.09290304;
  const FT_TO_M = 0.3048;
  function number(value, label, min, max) {
    if (value === '' || value === null || value === undefined || typeof value === 'boolean') throw new Error(label + ' is required.');
    const n = Number(value);
    if (!Number.isFinite(n) || n < min || n > max) throw new Error(label + ' must be between ' + min + ' and ' + max + '.');
    return n;
  }
  function unitFactor(unit) {
    if (unit !== 'm2' && unit !== 'ft2') throw new Error('Choose square metres or square feet.');
    return unit === 'ft2' ? SQFT_TO_M2 : 1;
  }
  const cents = n => Math.round((n + Number.EPSILON) * 100);
  function area(input) {
    const factor = unitFactor(input.unit);
    const wastage = number(input.wastage, 'Planning allowance', 0, 50);
    if (!Array.isArray(input.rooms) || input.rooms.length > 30) throw new Error('Use between 1 and 30 rooms.');
    const rooms = input.rooms.filter(r => r.include !== false).map((room, i) => {
      const name = String(room.name || 'Room ' + (i + 1)).slice(0, 100);
      let m2;
      if (room.mode === 'area') m2 = number(room.measured, name + ' measured area', 0.000001, 1000000) * factor;
      else if (room.mode === 'dimensions') {
        const length = number(room.length, name + ' length', 0.000001, 1000);
        const width = number(room.width, name + ' width', 0.000001, 1000);
        m2 = length * width * factor;
      } else throw new Error('Choose a measurement method for ' + name + '.');
      return { name, m2 };
    });
    if (!rooms.length) throw new Error('Include at least one room.');
    const netM2 = rooms.reduce((sum, r) => sum + r.m2, 0);
    const targetM2 = netM2 * (1 + wastage / 100);
    let packM2 = null, packs = null, orderM2 = targetM2;
    if (input.packCoverage !== '' && input.packCoverage !== null && input.packCoverage !== undefined) {
      packM2 = number(input.packCoverage, 'Coverage per pack', 0.000001, 1000000) * factor;
      const quotient = targetM2 / packM2;
      const tolerance = Math.min(1e-7, 1e-10 * Math.max(1, Math.abs(quotient)));
      packs = Math.ceil(quotient - tolerance);
      orderM2 = packs * packM2;
    }
    return { rooms, unit: input.unit, wastage, netM2, targetM2, packM2, packs, orderM2, allowanceM2: targetM2 - netM2, packRoundingM2: orderM2 - targetM2, excludedRooms: input.rooms.length - rooms.length };
  }
  function budget(input) {
    const areaFactor = unitFactor(input.areaUnit), rateFactor = unitFactor(input.rateUnit);
    const netM2 = number(input.netArea, 'Measured installation area', 0.000001, 1000000) * areaFactor;
    const orderM2 = number(input.orderArea, 'Material order area', 0.000001, 1500000) * areaFactor;
    if (orderM2 + 1e-8 < netM2) throw new Error('Material order area cannot be smaller than the measured installation area.');
    const materialRate = number(input.materialRate, 'Material rate', 0, 1000000);
    const installationRate = number(input.installationRate === '' ? 0 : input.installationRate, 'Installation rate', 0, 1000000);
    const materialQuantity = orderM2 / rateFactor, installationQuantity = netM2 / rateFactor;
    const materialCents = cents(materialQuantity * materialRate), installationCents = cents(installationQuantity * installationRate);
    if (!Array.isArray(input.extras) || input.extras.length > 30) throw new Error('Use no more than 30 additional cost lines.');
    const extras = input.extras.map((item, i) => {
      const name = String(item.name || 'Additional cost ' + (i + 1)).slice(0, 100);
      const quantity = number(item.quantity === '' ? 0 : item.quantity, name + ' quantity', 0, 1000000);
      const rate = number(item.rate === '' ? 0 : item.rate, name + ' unit price', 0, 1000000);
      if (rate > 0 && quantity === 0) throw new Error(name + ' needs a positive quantity for the entered unit price.');
      return { name, quantity, rate, unit: String(item.unit || 'lot').slice(0, 10), cents: cents(quantity * rate) };
    });
    const subtotalCents = materialCents + installationCents + extras.reduce((sum, e) => sum + e.cents, 0);
    if (!['none', 'excluded', 'included'].includes(input.gstMode)) throw new Error('Choose how GST is treated in the entered prices.');
    const gstRate = input.gstMode === 'none' ? 0 : number(input.gstRate, 'GST rate', 0, 100);
    const gstCents = input.gstMode === 'excluded' ? Math.round(subtotalCents * gstRate / 100) : 0;
    const includedGstCents = input.gstMode === 'included' ? Math.round(subtotalCents * gstRate / (100 + gstRate)) : 0;
    const estimateCents = subtotalCents + gstCents;
    const reserveRate = number(input.reserve === '' ? 0 : input.reserve, 'Contingency reserve', 0, 100);
    const reserveCents = Math.round(estimateCents * reserveRate / 100);
    if (![subtotalCents,gstCents,includedGstCents,estimateCents,reserveCents,estimateCents+reserveCents].every(Number.isSafeInteger)) throw new Error('The total exceeds the safe calculation range. Reduce the entered quantities or rates.');
    return { netM2, orderM2, materialRate, installationRate, rateUnit: input.rateUnit, materialQuantity, installationQuantity, materialCents, installationCents, extras, subtotalCents, gstMode: input.gstMode, gstRate, gstCents, includedGstCents, estimateCents, reserveRate, reserveCents, totalCents: estimateCents + reserveCents };
  }
  return { SQFT_TO_M2, FT_TO_M, area, budget, number };
});
